'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  text-align: center;\n  audio {\n    width: 100%;\n  }\n'], ['\n  text-align: center;\n  audio {\n    width: 100%;\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Audio = _styledComponents2.default.div(_templateObject);

var AudioContent = function (_Component) {
  _inherits(AudioContent, _Component);

  function AudioContent(props) {
    _classCallCheck(this, AudioContent);

    var _this = _possibleConstructorReturn(this, (AudioContent.__proto__ || Object.getPrototypeOf(AudioContent)).call(this, props));

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  _createClass(AudioContent, [{
    key: 'handleClick',
    value: function handleClick(event) {
      event.preventDefault();
      if (window.vexpo && window.vexpo.overlay) window.vexpo.overlay(this.props);
    }
    /** @function
     * Renders the Audio Content component.
     */

  }, {
    key: 'render',
    value: function render() {
      if (this.props.thumbnail !== undefined) {
        return _react2.default.createElement(
          'div',
          { onClick: this.handleClick },
          _react2.default.createElement('img', { src: this.props.thumbnail, alt: this.props.name }),
          this.props.caption
        );
      } else {
        return _react2.default.createElement(
          Audio,
          null,
          _react2.default.createElement('audio', { src: this.props.audio, autoPlay: 'true', controls: 'true' }),
          _react2.default.createElement('br', null),
          this.props.caption
        );
      }
    }
  }]);

  return AudioContent;
}(_react.Component);

exports.default = AudioContent;


AudioContent.propTypes = {
  audio: _propTypes2.default.string.isRequired,
  thumbnail: _propTypes2.default.string,
  caption: _propTypes2.default.string
};


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/content/audio-content.js
// module id = 1323
// module chunks = 0